export const UrlConstants = {
  FindAHealthCenter: 'findahealthcenter',
  HDSLocator: 'hdslocator',
  FindANetwork: 'findanetwork',
  OPTOXFind: 'opotxfind',
  FindHIVCare: 'findhivcare',
  GoogleMaps: 'https://www.google.com/maps/dir/'
};

export const PageNames = {
  FindAHealthCenterProgram: 'Find a Health Center',
  HivProgram: 'Find a Ryan White HIV/AIDS Program Medical Provider',
  OrganTransplantProgram: 'Find an Organ Transplant Center',
  MigrantHeadStartProgram: 'Find a Migrant and Seasonal Head Start Center',
  FindANetworkProgram: 'Find A Network'
};

export const SubHeaderText = {
  FindAHealthCenterProgram:
    'We fund about 1,400 health centers, which run more than 16,200 service sites. They are in all U.S. states, territories, and the District of Columbia. You can find them in cities, rural areas, and everywhere in between.',
  HivProgram: '',
  OrganTransplantProgram: '',
  MigrantHeadStartProgram: '',
  FindANetworkProgram: ''
};

export const MetaDescription = {
  FindAHealthCenter: 'Search for HRSA funded Health Centers',
  HDSLocator: 'Search for HRSA funded Migrant and Seasonal Head Start Health and MSHC Centers',
  FindANetwork: 'Locate a Health Center Controlled Network on Map by Zip Code or Street Address',
  OPTOXFind: 'Locate on map by address or zip code an Organ Transplant Cente',
  FindHIVCare: 'Enter your zip code, or address to find a Ryan White HIV/AIDS Program Medical Provider'
};

export const MetaKeyWords = {
  FindAHealthCenter: 'search, Health Centers, zip, street address, geolocation',
  HDSLocator: 'search, Health Centers, MSHS,  zip, Migrant, Seasonal, Head Start, street address, geolocation, locate',
  FindANetwork: 'Search, HCCN, Map, Controlled Network',
  OPTOXFind: 'Organ, Organ Procurement, Organ Transplantation, locate, mapping',
  FindHIVCare: 'Ryan White, HIV, AIDS, HIV/AIDS, geolocation'
};
